/**
 * Lane C0-PROPORTION: the B3 figure's temporary build flag (figureB3.ts), in a file of its own with no imports so
 * central files (sprites.ts, sets.ts) can read it without import cycles. Off until the port is shown to the user;
 * then on, and later removed with the old path.
 */
export const FIGURE_B3 = true;

let on: boolean = FIGURE_B3;
/** Whether figures are drawn B3 on this page. */
export const figureB3 = (): boolean => on;
/** Review tools only: draw B3 (true) or today's figure (false) on this page, before any frame is drawn. */
export function setFigureB3(v: boolean): void {
  on = v;
}

/**
 * The portrait's window on a standing frame (sprites.ts `drawPortrait`), art px: from `left` of the feet column and
 * `top` of the skeleton's top row, `size` square. B3's head is ×0.75 and rides 2.6 px higher, so its window is
 * smaller and higher, the face as large in the portrait as today's. `figureTop`: the frame's top row (art px from the
 * skeleton's top row), so a short figure's window starts at its own head.
 */
export const portraitWindow = (figureTop = 0): { left: number; top: number; size: number } =>
  // B3: never above the figure's own top row (a child is shorter: QA B3-R1 saw only hair in its portrait).
  on ? { left: 10, top: Math.max(0, figureTop), size: 20 } : { left: 12, top: 1, size: 26 };
